import { GetUserLocations } from 'domain/usecases/get-user-locations';
import { BaseHttpService } from 'main/factories/http';

export class RemoteGetUserLocations extends BaseHttpService<GetUserLocations.Model> implements GetUserLocations {
  async get(params: GetUserLocations.Params): Promise<GetUserLocations.Model> {
    return await this.request('get', {}, params);
  }
}
